import { BudgetVersionAttributes } from '@callmart/types';
import api from './index';

const BASE = '/budget-versions';

export interface BudgetVersion extends BudgetVersionAttributes {}

export const getBudgetVersions = async () => {
    return api.get(BASE).then((res) => res.data);
};

export const createBudgetVersion = async (data: {
    name: string;
    cloneFromId?: number;
    // CALL-758: the bucket the new draft lives in. Required for a fresh draft; for a clone it must
    // match the source's bucket (the backend rejects a mismatch).
    budgetBucketId?: number;
}) => {
    return api.post(BASE, data).then((res) => res.data);
};

export const updateBudgetVersion = async ({ id, ...data }: { id: number; name?: string; type?: string }) => {
    return api.patch(`${BASE}/${id}`, data).then((res) => res.data);
};

export const deleteBudgetVersion = async (id: number) => {
    return api.delete(`${BASE}/${id}`).then((res) => res.data);
};

export const createSnapshot = async (id: number): Promise<BudgetVersion> => {
    return api.post(`${BASE}/${id}/snapshot`).then((res) => res.data);
};

export const exportBudgetToExcel = async (id: number, extrapolate = true): Promise<Blob> => {
    // CALL-756: mirror the "Mit Extrapolation" toggle — extrapolate=false exports entered rates only.
    return api.get(`${BASE}/${id}/export`, { params: { extrapolate }, responseType: 'blob' }).then((res) => res.data);
};
